import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

import ValidatedPws from "../../components/ValidatedInput/ValidatedPws/ValidatedPws";
import ButtonFotter from "../../components/Button/ButtonFotter/ButtonFotter";
import OTPInput from "../../components/TextInput/OtpInput/OtpInput";
import Typography from "../../components/Typography/Typography";
import Button from "../../components/Button/Button";
import Loader from "../../components/Loader/Loader";
import Modal from "../../components/Modal/Modal";
import styles from "./LastSteps.module.scss";
import codes from "../../utils/codes";

import { StateContext } from "../../contexts/state.context";
import { createUser, validateOtp} from "../../utils/services";

import finalImage from "../../assets/finalImage.svg";

const RECAPTCHA_KEY = window.env.REACT_APP_GOOGLE_KEY;

const LastSteps = () => {
	const navigate = useNavigate();
	const { formData } = useContext(StateContext);

	const [pws, setPws] = useState();
	const [pwsError, setPwsError] = useState();
	const [pwsStrength, setPwsStrength] = useState({
		hasLowerCase: false,
		hasUpperCase: false,
		hasNumber: false,
		hasSpecialChar: false,
		isLongEnough: false,
		isTooLong: false,
	});

	const [otpData, setOtpData] = useState();

	const [rePws, setRePws] = useState();
	const [rePwsError, setRePwsError] = useState();

	const [otp, setOtp] = useState();
	const [otpError, setOtpError] = useState();

	const [loader, setLoader] = useState();
	const [modal, setModal] = useState(false);
	const [modalError, setModalError] = useState(false);
	const [modalErrorMjs, setModalErrorMjs] = useState("error");
	const [successModal, setSuccessModal] = useState(false);

	const [error, setError] = useState();
	const [errorMjs, setErrorMjs] = useState();

	const [token, setToken] = useState(null);
	const [captchaError, setCaptchaError] = useState(false);
	// Flujo POS: no se pasó por ValidateIdentity, así que no hay captchaToken.
	// El Endpoint 2 (headless) lo exige -> se muestra el reCAPTCHA desde el inicio.
	const [isCaptchaVisible, setIsCaptchaVisible] = useState(!!formData?.fromPos);

	const OTP_INVALID_MSG = "Código OTP incorrecto.";

	const handlePwsChange = (password) => {
		setPws(password);
		setPwsStrength({
			hasLowerCase: /[a-z]/.test(password),
			hasUpperCase: /[A-Z]/.test(password),
			hasNumber: /\d/.test(password),
			hasSpecialChar: /[!@#$%^&*()_+={}[\]:;"'<>,.?/\\|`~-]/.test(
				password,
			),
			isLongEnough: password.length >= 8,
			isTooLong: password.length <= 30,
		});
	};

	const isValidPws = (isValid) => {
		if (isValid) return styles.lastStepsItemValid;
		else return styles.lastStepsItemInvalid;
	};

	const validatePws = () => {
		const {
			hasLowerCase,
			hasNumber,
			hasSpecialChar,
			hasUpperCase,
			isLongEnough,
			isTooLong,
		} = pwsStrength;

		if (
			!hasLowerCase ||
			!hasNumber ||
			!hasSpecialChar ||
			!hasUpperCase ||
			!isLongEnough ||
			!isTooLong
		)
			return false;
		return true;
	};

	const handleDisabledBtn = () => {
		// if (pws && rePws)
		// 	if (isCaptchaVisible)
		// 		if (token) return false;
		// 		else return true;
		// 	else return false;
		// else return true;
		return !(pws && rePws && (!isCaptchaVisible || token));
	};

	const handleCreateClick = () => {
		if (!validatePws()) {
			setPwsError(true);
			return;
		}

		if (!rePws) {
			setRePwsError(true);
			return;
		}

		if (rePws !== pws) {
			setRePwsError(true);
			return;
		}

		if (isCaptchaVisible && !token) {
			setCaptchaError(true);
			return;
		}

		const rData = { ...formData };
		rData.password = pws;

		if (token) rData.captchaToken = token;

		// Flujo POS: canal de activación final = APP (CA-4)
		if (formData?.fromPos) rData.channelKey = "APP";

		setLoader(true);

		createUser({ formInfo: rData })
			.then(({ code, message }) => {
				switch (code) {
					case codes.JVB001.code:
						setModal(true);
						setOtpData(message);
						break;

					case codes.JVB007.code:
						setError(true);
						setErrorMjs("Error creando la cuenta");
						break;

					case codes.JVB009.code:
						setError(true);
						setErrorMjs(
							"Debe realizar nuevamente la validacion ReCaptcha",
						);
						setIsCaptchaVisible(true);
						break;
					
					case codes.JVB019.code:
						setError(true);
						setErrorMjs(
							"Tenemos una intermitencia con servicios externos. Intenta de nuevo en unos minutos.",
						);
						break;
					
					default:
						setError(true);
						setErrorMjs("Algo inesperado sucedió");
						break;
				}

				setLoader(false);
			})
			.catch((e) => {
				console.log(e.data);
				setLoader(false);
			});
	};

	const handleValidateAccount = () => {
		setModalError(false);
    	setModalErrorMjs("");
    	setOtpError(false);

		if (!otp) {
			setOtpError(true);
			return;
		}

		if (otp.length < 6) {
			setOtpError(true);
			return;
		}

		const rData = {
			requestIdentifier: otpData.requestIdentifier,
			otp: (otp || "").trim(),
		};

		setLoader(true);

		validateOtp({ formInfo: rData })
			.then(({ code }) => {
				setLoader(false);

				switch (code) {
					case codes.JVB001.code:
						setModalError(false);
                    	setModalErrorMjs("");
                    	setModal(false);
						setSuccessModal(true);
						break;
					
					case codes.JVB020.code:
					case codes.JVB006.code:
						setOtpError(true);
                    	setModalError(true);
                    	setModalErrorMjs(OTP_INVALID_MSG);
                    	break;

					case codes.JVB011.code:
						setModalError(true);
						setModalErrorMjs(
							"No pudimos validar tu cuenta con la información enviada..",
						);
						break;
					
					case codes.JVB019.code:
						setModalError(true);
						setModalErrorMjs(
							"No pudimos completar la validación por una intermitencia externa. Intenta nuevamente en unos minutos.",
						);
						break;
					
					default:
						setModalError(true);
						setModalErrorMjs("Algo inesperado sucedió");
						break;
				}
			})
			.catch((e) => {
				setLoader(false);

				const apiCode = e?.data?.code;

                if (
                    apiCode === codes.JVB020.code ||
                    apiCode === codes.JVB006.code
                ) {
                    setOtpError(true);
                    setModalError(true);
                    setModalErrorMjs(OTP_INVALID_MSG);
                    return;
                }
				
				setModalError(true);
				setModalErrorMjs("Algo inesperado sucedió");
				console.log(e);
			});
	};

	return (
		<div className={styles.lastStepsContainer}>
			<ValidatedPws
				className={styles.lastStepsTextInput}
				label="Crea una contraseña"
				placeholder="Escribe aquí tu contraseña"
				onChange={handlePwsChange}
				errorMessage="Contraseña inválida"
				error={pwsError}
				setError={setPwsError}
			></ValidatedPws>

			<div className={styles.lastStepsPwsValidations}>
				<ul className={styles.lastStepsList}>
					<li className={isValidPws(pwsStrength.hasLowerCase)}>
						Por lo menos una letra minúscula.
					</li>
					<li className={isValidPws(pwsStrength.hasUpperCase)}>
						Por lo menos una letra mayúscula.
					</li>
					<li className={isValidPws(pwsStrength.hasNumber)}>
						Por lo menos un número.
					</li>
					<li className={isValidPws(pwsStrength.hasSpecialChar)}>
						Por lo menos un caracter especial.
					</li>
					<li className={isValidPws(pwsStrength.isLongEnough)}>
						Mínimo 8 caracteres.
					</li>
				</ul>
			</div>

			<ValidatedPws
				className={styles.lastStepsTextInput}
				label="Escríbe de nuevo tu contraseña"
				placeholder="Escribe aquí tu contraseña"
				errorMessage="Las contraseñas no coinciden"
				onChange={setRePws}
				error={rePwsError}
				setError={setRePwsError}
			></ValidatedPws>

			<Typography color={error ? "red" : "transparent"}>
				{errorMjs}
			</Typography>

			{isCaptchaVisible && (
				<div className={styles.validateIdentityReCaptchaContainer}>
					<div className={styles.validateIdentityReCaptcha}>
						<ReCAPTCHA
							sitekey={RECAPTCHA_KEY}
							hl="es"
							onChange={(token) => {
								setCaptchaError(false);
								setToken(token);
								setError(false);
							}}
						></ReCAPTCHA>

						{captchaError && (
							<div
								className={
									styles.validateIdentityReCaptchaBorder
								}
							>
								<Typography
									className={
										styles.validateIdentityCaptchaError
									}
									variant="p2"
									color="red"
								>
									Debe realizar el reCAPTCHA
								</Typography>
							</div>
						)}
					</div>
				</div>
			)}

			<ButtonFotter
				onClick={handleCreateClick}
				disabled={handleDisabledBtn()}
			>
				Crear cuenta
			</ButtonFotter>

			{modal && (
				<Modal title="¡Valida tu cuenta!">
					<div>
						<Typography className={styles.modalText}>
							Hemos enviado un correo <br></br> electrónico a
							<br></br>{" "}
							<span className={styles.modalTextIsblue}>
								[{formData.email}]
							</span>{" "}
							<br></br> con un código de seis dígitos para validar
							tu cuenta. Escríbelo aquí:
						</Typography>

						<div className={styles.modalOtpCodeContainer}>
							<OTPInput
								error={otpError}
								onChange={(otp) => {
									setOtpError(false);
									setModalError(false);
        							setModalErrorMjs("");
									setOtp(otp);
								}}
							></OTPInput>
							<Typography
								className={styles.modalOtpPwsOTPErrorMessage}
								color={otpError ? "primary" : "transparent"}
							>
								Código OTP inválido.
							</Typography>
						</div>

						<Button
							className={styles.modalBtn}
							onClick={handleValidateAccount}
						>
							Validar cuenta
						</Button>

						<Typography
							variant="p3"
							className={styles.modalFooterTxt}
						>
							Recuerda revisar la carpeta de <br></br> Spam o
							Promociones.
						</Typography>

						<Typography
							color={modalError ? "red" : "transparent"}
							className={styles.modalFooterTxt}
						>
							{modalErrorMjs}
						</Typography>
					</div>
				</Modal>
			)}

			{successModal && (
				<div className={styles.finalImageModal}>
					<div className={styles.finalImageContainer}>
						<img
							src={finalImage}
							alt="final-image"
							className={styles.modalFinalImage}
						></img>
						<Button
							className={styles.modalFinalBtn}
							color="white"
							onClick={() => navigate("/login")}
						>
							Iniciar sesión
						</Button>
					</div>
				</div>
			)}

			{loader && <Loader></Loader>}
		</div>
	);
};

export default LastSteps;
